/* unplugin-vue-components disabled */import { render } from "./FooterPcMember.vue?vue&type=template&id=0fe99ae1&scoped=true"
import script from "./FooterPcMember.vue?vue&type=script&lang=js"
export * from "./FooterPcMember.vue?vue&type=script&lang=js"

import "./FooterPcMember.vue?vue&type=style&index=0&id=0fe99ae1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe99ae1"]])

export default __exports__